import moment from 'moment';
import qs from 'querystring';
import BN from 'bignumber.js';
import { React, PT, withRouter, WithData } from '@gasbuddy/react';
import { Table, Loader, Message, Menu, Icon, Button, Form } from 'semantic-ui-react';

function isNumeric(n) {
  return !Number.isNaN(parseFloat(n));
}

function getColumn({ data: { columns } }, ix) {
  return columns[ix];
}

function getPage({ search }) {
  const p = Number(qs.parse(search.substring(1)).page);
  if (Number.isSafeInteger(p) && Number(p) >= 1) {
    return p;
  }
  return 1;
}

class BaseReport extends React.PureComponent {
  static cell(value, column, ix, row) {
    let formatted = value;
    switch (column.type) {
      case 'money':
        formatted = isNumeric(value) ? `$${new BN(value.toString()).toFormat(2)}` : '-';
        break;
      case 'percentage':
        formatted = isNumeric(value) ? `${new BN(value.toString()).times(100).toNumber()}%` : '-';
        break;
      case 'date':
        formatted = moment(value).format(column.format || 'MM/DD/YYYY HH:mm:ss');
        break;
      default:
        break;
    }
    const link = row.links ? row.links[ix] : null;
    const cellAttrs = row.cells ? row.cells[ix] : {};
    if (link || row.link) {
      formatted = (<a href={link || row.link}>{formatted}</a>);
    }
    if (column.multiline && formatted) {
      formatted = formatted.toString().split('\n')
        .map((item, key) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={key}>
            {item}
            <br />
          </span>
        ));
    }
    return (
      <Table.Cell textAlign={column.align || 'left'} {...cellAttrs}>
        {formatted}
      </Table.Cell>
    );
  }

  onNext = () => {

  }

  onPrev = () => {

  }

  columnHeader = c => (
    <Table.HeaderCell textAlign={c.headerAlign || c.align || 'center'}>
      {c.title}
    </Table.HeaderCell>
  )

  row = row => (
    <Table.Row>
      {row
        .data
        .map((v, ix) => BaseReport
          .cell(v, getColumn(this.props, ix), ix, row, row.links ? row.links[ix] : null))}
    </Table.Row>
  )

  render() {
    const { reportId, data, history, page, fetch, loading } = this.props;

    if (!reportId || !data || loading) {
      return (
        <Loader active inline="centered" />
      );
    }
    if (!data.columns || !data.rows) {
      return (
        <Message error>
          Unable to run the report.
          <pre>{JSON.stringify(data, null, '\t')}</pre>
        </Message>
      );
    }
    const { rows, columns, offset, hasMore } = data;

    return (
      <div>
        <Table celled selectable>
          <Table.Header>
            {columns.map(this.columnHeader)}
          </Table.Header>
          <Table.Body>
            {rows.map(this.row)}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.Cell colSpan={2}>
                Results
                {' '}
                {offset + 1}
-
                {offset + data.rows.length}
              </Table.Cell>
              <Table.Cell colSpan={columns.length - 2} textAlign="right">
                <Menu pagination>
                  {offset > 0 && (
                    <Menu.Item
                      as="a"
                      icon
                      onClick={() => {
                        history.push(`?page=${page - 1}`);
                        fetch();
                      }}
                    >
                      <Icon name="left chevron" />
                    </Menu.Item>
                  )}
                  {hasMore && (
                    <Menu.Item
                      as="a"
                      icon
                      onClick={() => {
                        history.push(`?page=${page + 1}`);
                        fetch();
                      }}
                    >
                      <Icon name="right chevron" />
                    </Menu.Item>
                  )}
                </Menu>
              </Table.Cell>
            </Table.Row>
          </Table.Footer>
        </Table>
        <Form style={{ marginBottom: 50 }} method="POST" action={`/reports/export/${reportId}`}>
          <Button
            type="submit"
            secondary
          >
            <Icon name="download" />
            {' '}
Export All to CSV
          </Button>
        </Form>
      </div>
    );
  }
}

BaseReport.propTypes = {
  reportId: PT.string.isRequired,
  data: PT.shape({
    columns: PT.array,
    rows: PT.array,
  }),
  loading: PT.bool,
  page: PT.number.isRequired,
  history: PT.shape({
    push: PT.func.isRequired,
  }).isRequired,
  fetch: PT.func.isRequired,
};

BaseReport.defaultProps = {
  data: null,
  loading: true,
};

export const Report = withRouter(({ location, reportId, ...rest }) => (
  <WithData url={`/reports/run/${reportId}`} body={{ page: getPage(location) }}>
    <BaseReport {...rest} reportId={reportId} page={getPage(location)} />
  </WithData>
));

Report.propTypes = {
  reportId: PT.string.isRequired,
  location: PT.shape({
    search: PT.string,
  }).isRequired,
};
